import types from '../constants/types'

export const detailMutation = {
  [types.FETCH_DETAIL_REQUEST] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = true
    state[action.request]['didInvalidate'] = false
  },
  [types.FETCH_DETAIL_SUCCESS] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = false
    state[action.request]['didInvalidate'] = false
    state[action.request]['data'] = action.data.data || action.data.info
    state[action.request]['lastUpdated'] = (new Date()).getTime()
  },
  [types.FETCH_DETAIL_FAILURE] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = false
    state[action.request]['didInvalidate'] = true
  },
  [types.FETCH_DETAIL_INIT] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isFetching'] = false
    state[action.request]['didInvalidate'] = false
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/fetchdetail.js